export default function About() {
    return <>
        <div className="container body-text">
            <h2>Stay Connected</h2>
                <p className="intro-text">Join our community channels to stay informed about neighborhood news, events, and important updates.</p>

                <div className="communication-channel">
                <h3>Email Newsletter</h3>
                <p>Get neighborhood updates delivered directly to your inbox. Our email list is the primary way we share important announcements and event invitations.</p>
                <p><span className="figtree-bold">To join:</span> Send an email to <a className="web-link" href="mailto:ridgewoodcivic@gmail.com">ridgewoodcivic@gmail.com</a> with "Add me to email list" in the subject line.</p>
                </div>

                <div className="communication-channel">
                <h3>Facebook Community</h3>
                <p>Connect with neighbors and join conversations in our private Facebook group.</p>
                <p>Many of our neighbors are small business owners. If you need services, please post to the Ridgewood Civic (Cincinnati) Facebook message or on </p>
                <p><span className="figtree-bold">To join:</span> Search for "Ridgewood Civic (Cincinnati)" on Facebook and send a friend request. Please answer the two membership questions to be approved.</p>
                <a href="https://www.facebook.com/groups/1083004331754635" target="_blank" rel="noopener noreferrer" className="web-link">Visit our Facebook page</a>
                </div>

                <div className="communication-channel">
                <h3>Nextdoor</h3>
                <p>Join neighborhood discussions and stay updated on local happenings.</p>
                <p><span className="figtree-bold">To join:</span> Visit <a className="web-link" href="https://nextdoor.com/neighborhood/ridgewoodcivic--cincinnati--oh/" target="_blank" rel="noopener noreferrer">nextdoor.com</a> and subscribe to the "Ridgewood Civic" neighborhood.</p>
                </div>

        </div>
        
    </>
}